"use strict";

var AccountApi = require("../api/AccountApi");
var ActionsHelper = require("../actions/ActionsHelper");
var AccountStore = require("./AccountStore");

var ApiHelper = require("../shared/ApiHelper");
var BootstrapPrompt = require("../shared/BootstrapPrompt");
var Spinner = require("../client/Spinner");
var SubmitButtonHelper = require("../commonComponents/SubmitButtonHelper");
var WizardConstants = require("../constants/WizardConstants");

var textAreaSelector = `.childCommunicationsWriteTextArea`;
var writeCommunicationsSelector = `[data-component="childCommunicationsWrite"]`;

var ChildCommunicationsHelper = {
	saveChildCommunications: function (event) {
		event = this._getEventOrReturn(event, "Save Child Communications called successfully.");
		if (!event) {
			return false;
		}

		var message = AccountStore.get(WizardConstants.WIZARDS.CHILD_COMMUNICATIONS_MESSAGES).confirmSend;

		BootstrapPrompt.confirm({
			btnCancelLabel: window.BUTTON_LABELS.NO,
			btnOKLabel: window.BUTTON_LABELS.YES,
			message: message
		}, (result) => {
			if (result) {
				Spinner.showSpinner();

				var $target = $(event.target);
				var $textArea = $target.find(textAreaSelector);

				var communication = {};
				communication.communicationData = $textArea.val();
				//Get the current sponsorship id from the url.
				var sponsorshipId = window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1);

				AccountApi.childCommunicationsSaveCommunication(communication, sponsorshipId).done((data) => {
					var stayFunction = (overrideMessage) => {
						var successMessage = overrideMessage ? overrideMessage : AccountStore.get(WizardConstants.WIZARDS.CHILD_COMMUNICATIONS_MESSAGES).sendSuccess;

						BootstrapPrompt.success(successMessage, () => {
							window.location.reload();
						});
					};

					SubmitButtonHelper.performPostSubmitAction(writeCommunicationsSelector, {
						onNoPostSubmitAction: stayFunction,
						onNoStayMessage: stayFunction,
						onStayMessage: stayFunction
					});

				}).fail((jqXHR) => {
					Spinner.removeSpinner()
					ApiHelper.displayErrorMessage(jqXHR);
				});
			}
		});

		return false;
	},

	initializeListeners: function() {
		var $textArea = $(textAreaSelector);

		var handlePaste = (event) => {
			var clipboardData,
				pastedData,
				match;

			event.stopPropagation();
			event.preventDefault();

			clipboardData = event.clipboardData || (event.originalEvent ? event.originalEvent.clipboardData : undefined) || window.clipboardData;

			if (!clipboardData) {
				BootstrapPrompt.alert("Unable to access the clipboard");
				return;
			}

			pastedData = clipboardData.getData("Text");

			//Remove all HTML
			pastedData = pastedData.replace(/<.*?>/g, "");

			window.document.execCommand("insertHTML", false, pastedData);
		};
		var $communicationForm = $(writeCommunicationsSelector).find("form");

		$communicationForm.on("submit.childCommunicationsWrite", ChildCommunicationsHelper.saveChildCommunications.bind(this));
		$textArea.on("paste", handlePaste);
	},

	_getEventOrReturn: function (event, isDesignModeMessage) {
		return ActionsHelper.getEventOrReturn(event, AccountStore.get("isDesignMode"), isDesignModeMessage, /*preventDefaultInDesignMode*/false);
	}
}

module.exports = ChildCommunicationsHelper;